export default __webpack_public_path__ + "static/frameElement-DarkGreen-533c3d1ef381f4f4e11eb997f3759d71.png";